export type PaymentDueDateUnit = 'calendar' | 'banking';

const formatLocalDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getTodayLocalDate = (): string => formatLocalDate(new Date());

export const calculatePaymentDueDate = (startDate: string, collectionTerm: number, unit: PaymentDueDateUnit): string => {
    const dateParts = startDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!dateParts || !Number.isInteger(collectionTerm) || collectionTerm < 0) {
        throw new Error('A valid start date and non-negative whole-number collection term are required.');
    }

    const date = new Date(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]));
    if (date.getFullYear() !== Number(dateParts[1]) || date.getMonth() !== Number(dateParts[2]) - 1 || date.getDate() !== Number(dateParts[3])) {
        throw new Error('A valid start date is required.');
    }

    if (unit === 'calendar') {
        date.setDate(date.getDate() + collectionTerm);
        return formatLocalDate(date);
    }

    let bankingDaysAdded = 0;
    while (bankingDaysAdded < collectionTerm) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) {
            bankingDaysAdded += 1;
        }
    }

    return formatLocalDate(date);
};



// WEBPACK FOOTER //
// ./src/components/leases/sections/paymentDueDateCalculator.ts